import React, { useState } from 'react';
import { henleyFlagLink } from '../../../utils/utils';
import  styles from  './country-flag.module.scss'; // import CSS file with animation styles

const CountryFlag = ({ country, countryName, code, size }) => {
    // Support both old (country) and new (countryName + code) prop patterns
    const name = countryName || country;
    const iso2Code = code || 'None';
    const [imageError, setImageError] = useState(false);

    const imageURL = henleyFlagLink(iso2Code);

    const handleImageError = () => {
        // console.log(`Flag image failed to load for ${name} (${iso2Code}): ${imageURL}`);
        setImageError(true);
    };

    return (
      <span className={`${styles.countryFlag} ${size ? styles[size] : ''}`}>
          {!imageError && imageURL ? (
              <img
                  src={imageURL}
                  alt={name}
                  onError={handleImageError}
              />
          ) : (
              <div className={styles.flagFallback}>
                  {iso2Code && iso2Code !== 'None' ? iso2Code.toUpperCase() : '??'}
              </div>
          )}
          <span className={styles.countryName}>{name}</span>
      </span>
    )

}

export default CountryFlag;
